import React, { useEffect, useState } from "react"

import { Form, Label, Row, Col } from "reactstrap"

import toast from "react-hot-toast"
import { useUploadAuthorityLetterMutation } from "store/api/kyc/kyc"
import { useFormik } from "formik"
import * as Yup from "yup"
import { useSelector } from "react-redux"
import Spinners from "components/Common/Spinner"
import AuthorityLetterUpload from "./authorityLetterUpload"
import authorityLetter from "../../assets/sample/Authority-Letter.pdf"
import authorityLetterWP from "../../assets/sample/Authority-Letter-Wealth-Partner.pdf"
import UploadedFileBox from "./uploadedFileBox"
import KYCPrevButton from "./kycPrevButton"

const defaultValues = {
  authority_letter: "",
}

const KycAuthorityLetter = ({ kycData }) => {
  const { userType } = useSelector((state) => state.user)
  const [uploadAuthorityLetter, { isLoading }] =
    useUploadAuthorityLetterMutation()

  const validation = useFormik({
    initialValues: { ...defaultValues },
    validationSchema: Yup.object({}),
    validateOnMount: false,
    onSubmit: (values) => {
      onFormSubmit(values)
    },
  })

  useEffect(() => {
    if (kycData) {
      validation.setFieldValue(
        "authority_letter",
        kycData?.businessAdditionalDetails?.authority_letter
      )
    }
  }, [kycData])

  const onFormSubmit = async (values) => {
    try {
      const { success } = await uploadAuthorityLetter({
        ...values,
        kycStep: kycData.status,
      }).unwrap()
      if (success) {
        window.location.reload()
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toasterMessage" })
    }
  }

  return (
    <>
      <div className="bank-details-wrapper">
        <h5 className="title mb-3">Upload Authority Letter</h5>
        <p>Please upload document</p>
        <Form onSubmit={validation.handleSubmit}>
          <Row className="mb-2">
            <Col xl={12}>
              <Label className="col-form-label">
                Authority Letter <span className="error">*</span>
              </Label>
              <div className="upload-file-input">
                <a
                  href={
                    userType === "INVESTOR"
                      ? authorityLetter
                      : authorityLetterWP
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="sample-form">Download Sample Letter</div>
                </a>
                <AuthorityLetterUpload
                  fieldKey={"authority_letter"}
                  validation={validation}
                  extensionAllowedInput={".pdf"}
                  extensionAllowed={["application/pdf"]}
                  preview={true}
                  kycData={kycData}
                />
              </div>
            </Col>

            <Col sm={12}>
              <Row className="mt-4">
                <KYCPrevButton
                  kycData={kycData}
                  disabled={isLoading}
                  ButtonHtml={
                    <button type="submit" className="btn btn-primary w-100">
                      {isLoading ? <Spinners /> : "Save & Next"}
                    </button>
                  }
                />
              </Row>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  )
}

export default KycAuthorityLetter
